export default __webpack_public_path__ + "static/media/lettermixup_locked.1ae429c5.svg";